<!-- Sidebar -->
<ul class="navbar-nav sidebar accordion pt-2 menu_bar" style="width: 267px" >

  <!-- Sidebar - Brand -->


  <li class="nav-item ">
    <a class="nav-link"  href="/xps/landing" >
    <!-- <img src="xps/assets/img/home_icon.jpg" /> -->
      <span >Home</span>
    </a>        
  </li>

  <li class="nav-item ">
    <a class="nav-link"  href="/xps/search" >
      <!-- <img src="./xps/asset/img/viewpolicy1.svg"> -->
      <span >View all Policies and Quotes </span>
    </a>        
  </li>

  <li class="nav-item ">
    <a class="nav-link" href="/xps/policyQuotes" (click)="policy('Manage a Policy')">
      <!-- <img src="./xps/asset/img/managingpolicy.svg"> -->
      <span >Manage a Policy </span>
    </a>        
  </li>


  <li class="nav-item ">
    <a href="/xps/reportclaim" class="nav-link">
      <!-- <img src="./xps/asset/img/reportpolicy.svg"> -->
      <span >Report a Claim </span>
    </a>        
  </li>

  <li class="nav-item ">
    <a class="nav-link" href="/xps/evidenceofinsurance">
      <!-- <img src="./xps/asset/img/requestingpolicy.svg"> -->
      <span >Request Evidence of Insurance </span>
    </a>        
  </li>

  <li class="nav-item ">
    <a class="nav-link" href="/policyQuotes" (click)="policy('Cancel My Policy')">
      <!-- <img src="./xps/asset/img/cancelpolicy.svg"/> -->
      <span >Cancel a Policy</span>
    </a>        
  </li>

  <!-- Nav Item - Pages Collapse Menu -->
  <!-- <li class="nav-item ">
    <a class="nav-link"  [routerLink]="['/Search']" >
      <i class="fa fa-search"></i>
      <span>Search</span>
    </a>        
  </li>
  <li class="nav-item">
    <a class="nav-link" [routerLink]="['/SearchResult']" >
      <i class="fa fa-list-ul"></i>
      <span>Search Results</span>
    </a>        
  </li>
   <li class="nav-item active">
    <a class="nav-link" [routerLink]="['/Policy']">
      <i class="fa fa-file-text"></i>
      <span>Policy</span>
    </a>        
  </li> -->




  <!-- Divider -->
  <!-- <hr class="sidebar-divider d-none d-md-block"> -->

  <!-- Sidebar Toggler (Sidebar) -->
  <!-- <div class="text-center d-none d-md-inline">
    <button class="rounded-circle border-0" id="sidebarToggle"></button>
  </div> -->

</ul>

<div class="sidebar mt-2 pt-2 pl-2 pr-2 menu_bar" style="width: 267px">
<div class="text-center">
   <h6 ><b>Need Support?</b></h6>
</div>
<p>
  <b>Your Berkley Fire & Marine Underwriter:</b> <br/>
  {{needSupport?.underwriterInformation?.name}}<br/>
  Direct Phone | {{needSupport?.underwriterInformation?.directPhone}}<br/>
  Email : {{needSupport?.underwriterInformation?.emailAddress}}
</p>
<p>
  <b>Service Center:</b><br/>
  Phone | {{needSupport?.bfmSupportInformation[0]?.telephoneNumber}}<br/>
  Email | {{needSupport?.bfmSupportInformation[0]?.emailAddress}}<br/>
  Hours | {{needSupport?.bfmSupportInformation[0]?.address?.openingHours}} EST
</p>
<p>
  <b>Mailing Address:</b> <br>
  {{needSupport?.bfmSupportInformation[0]?.address?.addressLine1}}<br/>
  {{needSupport?.bfmSupportInformation[0]?.address?.addressLine2}}<br/>
  {{needSupport?.bfmSupportInformation[0]?.address?.city}}, {{needSupport?.bfmSupportInformation[0]?.address?.state}} {{needSupport?.bfmSupportInformation[0]?.address?.zip}}
</p>
<p>
  <b>{{needSupport?.bfmSupportInformation[1]?.name}}:</b><br/>
  {{needSupport?.bfmSupportInformation[1]?.telephoneNumber}}<br/>
  <a class="sidemenu_links" href="#">{{needSupport?.bfmSupportInformation[1]?.emailAddress}}</a>
</p>
<p>
  <b>{{needSupport?.bfmSupportInformation[2]?.name}}:</b><br/>
  {{needSupport?.bfmSupportInformation[2]?.telephoneNumber}}<br/>
  <a class="sidemenu_links" href="#">{{needSupport?.bfmSupportInformation[2]?.emailAddress}}</a>
</p>
<p>
  <b>{{needSupport?.bfmSupportInformation[3]?.name}}:</b><br/>
  {{needSupport?.bfmSupportInformation[3]?.telephoneNumber}}<br/>
  <a class="sidemenu_links" href="#">{{needSupport?.bfmSupportInformation[3]?.emailAddress}}</a>
</p>
</div>

<!-- End of Sidebar -->

<!-- <a [routerLink]="['./autoclaim']">Auto claim</a><br>
<a [routerLink]="['./propertyclaim']">Property claim</a><br> -->
